import { render, staticRenderFns } from "./ZonesLegend.vue?vue&type=template&id=b8114962&scoped=true&"
import script from "./ZonesLegend.vue?vue&type=script&lang=js&"
export * from "./ZonesLegend.vue?vue&type=script&lang=js&"
import style0 from "./ZonesLegend.vue?vue&type=style&index=0&id=b8114962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8114962",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent,VListItemIcon,VListItemSubtitle,VListItemTitle})
